import React, { FC } from 'react';
import { Button, Result } from 'antd';
import { ResultProps } from 'antd/lib/result';
import { useTranslation } from 'react-i18next';
import { Transaction } from '~/types';
import { ClockCircleFilled } from '@ant-design/icons';

interface Props extends ResultProps {
  transaction?: Transaction;
  onClose: () => void;
}

const TransactionResult: FC<Props> = (props) => {
  const { transaction, onClose, ...rest } = props;
  const [t] = useTranslation('transactions');

  const transactionStatus = transaction?.status;
  const isCompleted = transactionStatus === 'COMPLETED';
  const isRejected = transactionStatus === 'REJECTED';

  return (
    <Result
      icon={!isCompleted && !isRejected ? <ClockCircleFilled /> : undefined}
      status={isCompleted ? 'success' : isRejected ? 'error' : 'info'}
      title={
        isCompleted
          ? t('Transfer done')
          : isRejected
          ? t('Transfer rejected')
          : t('Transfer in progress')
      }
      subTitle={t('transferId', { id: transaction?.id })}
      extra={
        <Button type="primary" onClick={onClose}>
          {t('translation:close')}
        </Button>
      }
      {...rest}
    />
  );
};

export default TransactionResult;
